import React, {useEffect} from 'react';
import {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
} from '@ionic/react';
import {
    menuOutline,
    home,
    briefcase,
    heart,
    clipboard,
    calendar,
    newspaper,
    cash,
    notifications as notificationsIcon, logOut,
} from 'ionicons/icons';
import appLogo from '../theme/images/logo-big.png';
import {useHistory, useLocation} from "react-router";
import {
    actionToGetAllNotification,
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {hideBanner} from "../lib/ads";

const menuDesktopTopItems = [
    { label: 'Home', icon: home, pathName: '/dashboard/home' },
    { label: 'Jobs', icon: briefcase, pathName: '/dashboard/job-portal' },
    { label: 'Assignments', icon: clipboard, pathName: '/dashboard/assignments' },
    { label: 'Matrimonial', icon: heart, pathName: '/dashboard/matrimonial' },
    { label: 'Events', icon: calendar, pathName: '/dashboard/events' },
    { label: 'Newsletter', icon: newspaper, pathName: '/dashboard/newsletter' },
    { label: 'Contribute', icon: cash, pathName: '/dashboard/contribute' },
];


const HeaderAfterLoginComponent = ({hideHeader,menuRef,setCurrentPath,panelSubHeader = null,menuOpen,setMenuOpen,isMobile,callFunctionToLogoutUser}) => {
    const {setNotificationSheetOpen,notificationsDataState,userAuthDetail} = useStore();
    const {pathname} = useLocation();
    const history = useHistory();
    const {notifications} = notificationsDataState;
    const {userInfo} = userAuthDetail;


    const goToPage =(page)=>{
        const menu = menuRef.current;
        if(isMobile){
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }else{
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }
    }

    useEffect(() => {
        // Setup menu event listeners when component mounts
        const setupMenuListeners = () => {
            const menu = document.querySelector('ion-menu');
            if (menu) {
                menuRef.current = menu;
                menu.addEventListener('ionDidOpen', handleMenuOpen);
                menu.addEventListener('ionDidClose', handleMenuClose);
            }
        };

        const handleMenuOpen = () => setMenuOpen(true);
        const handleMenuClose = () => setMenuOpen(false);

        // Ionic components might not be ready immediately
        const timer = setTimeout(setupMenuListeners, 300);

        return () => {
            clearTimeout(timer);
            if (menuRef.current) {
                menuRef.current.removeEventListener('ionDidOpen', handleMenuOpen);
                menuRef.current.removeEventListener('ionDidClose', handleMenuClose);
            }
        };
    }, []);

    const toggleMenu = () => {
        const menu = menuRef.current; // pass this ref down via props
        if (!menu) return;
        menu.isOpen().then((open) => {
            if(open){
                menu.close()
            }else{
                menu.open()
                hideBanner();
            }
        });
    };

    useEffect(() => {
        actionToGetAllNotification();
    }, []);


    return (
        <IonHeader className={`with_login-header main_app_header`}>
            <IonToolbar className={`with_login-toolbar with_sub_heading_toolbar ${hideHeader ? 'hide_element' : ''}`}>
                {isMobile && (
                    <IonButtons slot="start">
                        <IonButton
                            onClick={toggleMenu}
                            className={`with_login-menu-button ${menuOpen ? 'open' : ''}`}
                        >
                            <div className="profile-avatar">
                                <div className={"user_name_initial"}>
                                    {(userInfo?.profile_image_url) ?
                                        <div className={"user_avatar_img_in_profile"}>
                                            <img src={userInfo?.profile_image_url} alt={userInfo?.name}/>
                                        </div>
                                        :
                                        <div className={"user_name"}>
                                            {userInfo?.name?.substr(0,1).toUpperCase()}
                                        </div>
                                    }
                                </div>
                                <IonIcon icon={menuOutline} className="avatar-icon"/>
                            </div>
                        </IonButton>
                    </IonButtons>
                )}
                {!isMobile && (
                    <IonButtons slot="start">
                        <IonButton
                            onClick={toggleMenu}
                            className={`with_login-menu-button-desktop ${menuOpen ? 'open' : ''}`}>
                            <IonIcon icon={menuOutline} className="avatar-icon menu-hamburger" />
                        </IonButton>
                    </IonButtons>
                )}

                {isMobile ? (
                        <div slot="start" className="with_login-title_in_center_mob">
                            <img src={appLogo} alt="Logo" className="with_login-logo-mob"/>
                        </div>
                    )
                    : (
                        <IonTitle slot="start" className="with_login-title">
                            <img src={appLogo} alt="Logo" className="with_login-logo"/>
                        </IonTitle>
                    )}

                {!isMobile && (
                    <IonButtons slot="start" className="with_login-desktop-menu">
                        {menuDesktopTopItems.map((item, index) => (
                            <div
                                key={index}
                                className="menu-item-wrapper desktop-menu-top"
                            >
                                <div
                                    className={`menu-item ${
                                        pathname === item?.pathName ? 'active' : ''
                                    }`}
                                    onClick={() => goToPage(item.pathName)}
                                >
                                    <span>{item.label}</span>
                                    {item.children && <span className="arrow">▾</span>}
                                </div>
                            </div>
                        ))}
                    </IonButtons>
                )}
                <IonButtons slot="end" className="with_login-icons">
                    <IonButton onClick={()=>setNotificationSheetOpen(true)} className="header_button">
                        <div className="notification-icon">
                            <IonIcon icon={notificationsIcon}/>
                            {(notifications?.length) ?
                                <span className="notification-badge">{notifications?.length}</span>:''
                            }
                        </div>
                    </IonButton>
                    {!isMobile && (
                        <IonButton onClick={() => callFunctionToLogoutUser()} className="header_button">
                            <div className="notification-icon">
                                <IonIcon icon={logOut}/>
                            </div>
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            {/*////// FOR SUB HEADER PANEL /////*/}
            {panelSubHeader && (
                <IonToolbar className="with_login-toolbar">
                    {panelSubHeader()}
                </IonToolbar>
            )}
            {/*////// FOR SUB HEADER PANEL /////*/}
        </IonHeader>
    );
};

export default HeaderAfterLoginComponent;